//@flow
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
  loadingWrap: {
    // pointerEvents: 'none',
    zIndex: 1301,
    backgroundColor: 'rgb(244,244,246,0.8)',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    position: 'fixed',
  },
  iconWrap: {
    pointerEvents: 'none',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default function LoadingSpinner() {
  const classes = useStyles();

  return (
    <div className={classes.loadingWrap}>
      <div className={classes.iconWrap}>
        <CircularProgress size={80} />
      </div>
    </div>
  );
}
